var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9983 15.8402C14.9983 20.0381 13.5223 24.0642 10.8949 27.0326C8.26759 30.001 4.70415 31.6686 0.988525 31.6686V15.8402H14.9983Z",
    fill: "#F9B24E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.0115 15.8402C29.0115 17.9188 28.6491 19.9771 27.9451 21.8975C27.241 23.8179 26.209 25.5628 24.9081 27.0326C23.6072 28.5024 22.0628 29.6683 20.363 30.4638C18.6633 31.2592 16.8415 31.6686 15.0017 31.6686V15.8402H29.0115Z",
    fill: "#A8BBC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9983 15.8285C14.9978 13.7494 15.36 11.6906 16.0641 9.76967C16.7683 7.84879 17.8005 6.10349 19.1019 4.63353C20.4033 3.16357 21.9483 1.99775 23.6486 1.20271C25.349 0.407665 27.1713 -0.00102157 29.0115 1.91763e-06V15.8285H14.9983Z",
    fill: "#45525B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.988526 15.8285C0.988073 13.7497 1.35012 11.6912 2.05402 9.77057C2.75792 7.84994 3.78985 6.10482 5.09087 4.6349C6.39189 3.16499 7.93651 1.9991 9.63646 1.20382C11.3364 0.408551 13.1584 -0.000511217 14.9983 4.79467e-07V15.8285H0.988526Z",
    fill: "#FE7E02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d47df5406c82335297b1a69c0d5961d.svg";
export { ForwardRef as ReactComponent };